import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { motion } from "framer-motion";
import { CheckCircle2, XCircle } from "lucide-react";
import api from "@/lib/api";

export default function TicketView() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/tickets/lookup/${token}`).then((r) => setData(r.data)).catch(() => setErr(true));
  }, [token]);

  if (err)
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-6">
        <XCircle size={48} className="text-brand-orange" />
        <p className="font-head text-2xl font-bold uppercase">Ticket not found</p>
        <Link to="/tickets" className="font-mono text-xs uppercase tracking-widest text-brand-orange">Buy a ticket →</Link>
      </div>
    );

  if (!data) return <div className="min-h-screen flex items-center justify-center font-mono text-sm">Loading ticket…</div>;

  const { ticket, event } = data;
  const used = ticket.status === "used";

  return (
    <div className="min-h-screen bg-brand-ink flex items-center justify-center p-4 md:p-6">
      <motion.div
        initial={{ y: 40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ ease: [0.22, 1, 0.36, 1], duration: 0.6 }}
        className="w-full max-w-sm"
        data-testid="ticket-view"
      >
        <div className="bg-brand-orange text-white p-6">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em]">MARKIE 2 FRESH</div>
          <h1 className="font-head font-extrabold text-4xl uppercase leading-none mt-2">{event?.title}</h1>
          <p className="text-white/80 text-sm mt-2">{event?.venue} — {event?.city}</p>
          <p className="font-mono text-xs mt-1">{event?.date} · {event?.time}</p>
        </div>

        <div className="bg-white clip-ticket relative">
          <div className="border-t-2 border-dashed border-brand-ink/15" />
          <div className="p-8 flex flex-col items-center">
            <div className="p-4 bg-white border border-brand-ink/10">
              <QRCodeSVG value={ticket.qr_token} size={200} fgColor="#0A0A0A" level="M" data-testid="ticket-qr" />
            </div>
            <div className="font-mono text-[10px] tracking-widest text-brand-ink/40 mt-4">{ticket.qr_token}</div>

            <div className="mt-6 w-full flex items-center justify-between border-t border-brand-ink/10 pt-4">
              <div>
                <div className="font-mono text-[10px] uppercase tracking-widest text-brand-ink/40">Guest</div>
                <div className="font-head font-bold">{ticket.buyer_name}</div>
              </div>
              <div className={`flex items-center gap-1.5 font-mono text-xs uppercase tracking-widest ${used ? "text-brand-ink/40" : "text-brand-orange"}`} data-testid="ticket-status">
                {used ? <XCircle size={16} /> : <CheckCircle2 size={16} />}
                {used ? "Checked in" : "Valid"}
              </div>
            </div>
          </div>
        </div>
        <p className="text-center text-white/40 text-xs mt-5 font-mono">Show this QR code at the door</p>
      </motion.div>
    </div>
  );
}
